export const getCookies = () => {
    if (typeof window !== "undefined") {
        return document.cookie
            .split(";")
            .map((it) => {
            const [key, value] = it.split("=");
            return [key.trim(), value];
        })
            .reduce((acc, current) => ({ ...acc, [current[0]]: current[1] }), {});
    }
    return {};
};
export const cookieExist = (cookie) => !!getCookies()[cookie];
export const getCookie = (cookieName) => getCookies()[cookieName];
export const appendQueryParam = (href, encodedUrl) => {
    if (href.indexOf("requestedUrl=") > -1) {
        return href;
    }
    if (href.indexOf("?") > -1) {
        return href + "&requestedUrl=" + encodedUrl;
    }
    return href + "?requestedUrl=" + encodedUrl;
};
export function getInitials(name) {
    const words = name.trim().split(/\s+/);
    const initials = words
        .slice(0, 1)
        .map((word) => word.charAt(0).toUpperCase())
        .join("");
    return initials;
}
//# sourceMappingURL=util.js.map